import useBook from "@/composables/useBook";
import { CalculatePriceRequest } from "@/models/api/CalculatePriceRequest";
import { DirectionEnum } from "@/models/enums";
import { BookingSummary, BookingSummarySection } from "@/models/www/store/BookingSummary";
import calculateService from "@/services/calculate.service";
import { useBookingSummaryStore } from "@/store/basket";
import { useBookingStore } from "@/store/booking";

const useCalculatePrice = () => {
	const { getIdentifiersFromState, bookingTypes } = useBook();
	const bookingStore = useBookingStore();
	const bookingSummary = useBookingSummaryStore();

	const calculate = () => {
		const identifiers = getIdentifiersFromState();

		return calculateService.calculatePrice(
			{
				couponCode: "",
				identifiers: identifiers,
				types: bookingTypes.value,
				currency: ""
			} as CalculatePriceRequest).then(resp => {
				setSummary(resp);
			});
	}

	const setSummary = (summary: BookingSummary) => {
		const outwardRoute = bookingStore.getRoute(DirectionEnum.Outward);
		const returnRoute = bookingStore.getRoute(DirectionEnum.Return);
		//sort summary on outward/return
		const sort = (a: BookingSummarySection, b: BookingSummarySection) => {
			if (a.route === outwardRoute && b.route === returnRoute) {
				return -1;
			} else if (a.route === returnRoute && b.route === outwardRoute) {
				return 1;
			} else {
				return 0;
			}
		}

		//If we get the same amount of sections to cover all trips, replace the booking summary
		if (summary.bookingSections.length < 2 && bookingSummary.getBookingSummarySections) {
			//Keep the section not included in the response
			const routes = summary.bookingSections.map(s => s.route);

			const currentSections = bookingSummary.getBookingSummarySections.filter(s => !routes.includes(s.route));
			const newSections = [...summary.bookingSections, ...currentSections];

			summary.bookingSections = newSections.sort(sort);
			bookingSummary.setBookingSummary(summary);
		}
		else {
			summary.bookingSections = summary.bookingSections.sort(sort);
			bookingSummary.setBookingSummary(summary);
		}
	}

	return { calculate, setSummary }
}

export default useCalculatePrice;